import React, { useState } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Mailcheck from 'mailcheck';
import CtaSpinner from 'web-ui-kit/assets/CtaSpinner';
import { primaryM, secondaryHighlightM, redAlert } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_LANDSCAPE_BELOW } from 'web-ui-kit/media';
import { semiBold } from 'web-ui-kit/heading';
import { fontFamilyHeadings, fontFamilyPrimary } from 'web-ui-kit/typography';
import Dropdown, { styles as styles$1 } from 'web-ui-kit/SelectionControls/Dropdown';
import { buildCompressedUrl } from 'web-services/Imgix';
import bgImage from 'web-ui-kit/assets/login-background-new.jpg';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var SUGGESTED_DOMAINS = ['gmail.com', 'yahoo.com', 'hotmail.com', 'aol.com', 'hotmail.com', 'msn.com', 'outlook.com', 'modsy.com', 'mail.com', 'icloud.com'];

var _title, _description, _heading, _subheading, _passwordInput, _cta, _ctaBusy, _success, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

var MODES = {
  LOGIN: 'login',
  SIGNUP_PACKAGE_SELECTION: 'login-package-selection',
  SET_PW_SUBMIT: 'set-password-submit',
  RESET_PW_REQUEST: 'reset-password-request',
  RESET_PW_SUBMIT: 'reset-password-submit'
};

function LoginResetPassword(_ref) {
  var _ref$confirmPassword = _ref.confirmPassword,
      confirmPassword = _ref$confirmPassword === void 0 ? '' : _ref$confirmPassword,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$email = _ref.email,
      email = _ref$email === void 0 ? '' : _ref$email,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? MODES.LOGIN : _ref$mode,
      _ref$password = _ref.password,
      password = _ref$password === void 0 ? '' : _ref$password,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === void 0 ? false : _ref$submitting,
      _ref$submitted = _ref.submitted,
      submitted = _ref$submitted === void 0 ? false : _ref$submitted,
      _ref$partnerQuestionA = _ref.partnerQuestionAnswers,
      partnerQuestionAnswers = _ref$partnerQuestionA === void 0 ? [] : _ref$partnerQuestionA,
      _ref$partnerQuestion = _ref.partnerQuestion,
      partnerQuestion = _ref$partnerQuestion === void 0 ? '' : _ref$partnerQuestion,
      _ref$refferalPartner = _ref.refferalPartner,
      refferalPartner = _ref$refferalPartner === void 0 ? '' : _ref$refferalPartner,
      _ref$setRefferalPartn = _ref.setRefferalPartner,
      setRefferalPartner = _ref$setRefferalPartn === void 0 ? function () {} : _ref$setRefferalPartn,
      _ref$redirectUrl = _ref.redirectUrl,
      redirectUrl = _ref$redirectUrl === void 0 ? '' : _ref$redirectUrl,
      _ref$Link = _ref.Link,
      Link = _ref$Link === void 0 ? function (_ref2) {
    var children = _ref2.children,
        to = _ref2.to;
    return (
      /*#__PURE__*/
      React.createElement("a", {
        href: to
      }, children)
    );
  } : _ref$Link;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      warnings = _useState2[0],
      setWarnings = _useState2[1];

  var EmailSuggestion = function EmailSuggestion(_ref3) {
    var _ref3$emailSuggestion = _ref3.emailSuggestion,
        emailSuggestion = _ref3$emailSuggestion === void 0 ? '' : _ref3$emailSuggestion;

    var handleSuggestionClick = function handleSuggestionClick() {
      setWarnings(null);
      dispatch({
        type: 'change',
        payload: {
          field: 'email',
          value: emailSuggestion
        }
      });
    };

    return (
      /*#__PURE__*/
      React.createElement(EmailSuggestionMessage, null, "Did you mean ",
      /*#__PURE__*/
      React.createElement("span", {
        onMouseDown: handleSuggestionClick
      }, emailSuggestion), "?")
    );
  };

  var validateEmailSpelling = function validateEmailSpelling(value) {
    Mailcheck.run({
      email: value,
      domains: SUGGESTED_DOMAINS,
      secondLevelDomains: [],
      topLevelDomains: [],
      suggested: function suggested(suggestion) {
        setWarnings({
          emailSuggestion: suggestion.full
        });
      },
      empty: function empty() {
        setWarnings(null);
      }
    });
  };

  var handleChange = function handleChange(field) {
    return function (e) {
      dispatch({
        type: 'change',
        payload: {
          field: field,
          value: e.target.value
        }
      });
    };
  };

  var handleBlur = function handleBlur(field) {
    return function (e) {
      if (field === 'email') {
        validateEmailSpelling(e.target.value);
      }

      dispatch({
        type: 'change',
        payload: {
          field: field,
          value: e.target.value
        }
      });
    };
  };

  var handleLogin = function handleLogin(e) {
    e.preventDefault();
    dispatch({
      type: 'submit'
    });
  };

  var renderEmailInput = mode === MODES.LOGIN || mode === MODES.SIGNUP_PACKAGE_SELECTION || mode === MODES.RESET_PW_REQUEST;
  var renderPasswordInput = mode === MODES.LOGIN || mode === MODES.RESET_PW_SUBMIT || mode === MODES.SET_PW_SUBMIT;
  var renderConfirmPasswordInput = mode === MODES.RESET_PW_SUBMIT || mode === MODES.SET_PW_SUBMIT;
  var renderForgotPasswordLink = mode === MODES.LOGIN;
  var renderReferalAndTC = mode === MODES.SIGNUP_PACKAGE_SELECTION;
  var BackgroundImageContainer = styles.BackgroundImageContainer,
      BackgroundImage = styles.BackgroundImage,
      EmailSuggestionMessage = styles.EmailSuggestionMessage,
      ForgotContain = styles.ForgotContain,
      BottomLinksContainer = styles.BottomLinksContainer,
      InputContainer = styles.InputContainer,
      LoginBody = styles.LoginBody,
      LoginContainer = styles.LoginContainer,
      LoginError = styles.LoginError,
      LoginForm = styles.LoginForm,
      LoginMessage = styles.LoginMessage,
      LoginPage = styles.LoginPage,
      SelectMenuItem = styles.SelectMenuItem,
      SetPasswordContainer = styles.SetPasswordContainer,
      SetPasswordLink = styles.SetPasswordLink,
      Spinner = styles.Spinner,
      SubmitButton = styles.SubmitButton,
      SubmitText = styles.SubmitText,
      SuccessButton = styles.SuccessButton,
      Success = styles.Success;
  return (
    /*#__PURE__*/
    React.createElement(LoginPage, null,
    /*#__PURE__*/
    React.createElement(Helmet, {
      title: copy.title[mode],
      meta: [{
        name: 'description',
        content: copy.description[mode]
      }]
    }),
    /*#__PURE__*/
    React.createElement(LoginBody, null,
    /*#__PURE__*/
    React.createElement(LoginContainer, null,
    /*#__PURE__*/
    React.createElement(LoginForm, {
      onSubmit: handleLogin,
      name: "login",
      submitted: submitted,
      mode: mode
    },
    /*#__PURE__*/
    React.createElement(LoginMessage, null,
    /*#__PURE__*/
    React.createElement("h1", null, copy.heading[mode]),
    /*#__PURE__*/
    React.createElement("h5", null, copy.subheading[mode])), renderEmailInput &&
    /*#__PURE__*/
    React.createElement(InputContainer, null,
    /*#__PURE__*/
    React.createElement("label", {
      htmlFor: "email"
    }, "Email"),
    /*#__PURE__*/
    React.createElement("input", {
      id: "email",
      disabled: submitting,
      tabIndex: 1,
      value: email,
      onBlur: handleBlur('email'),
      onChange: handleChange('email'),
      type: "email"
    })), warnings &&
    /*#__PURE__*/
    React.createElement(EmailSuggestion, {
      emailSuggestion: warnings.emailSuggestion
    }), renderPasswordInput &&
    /*#__PURE__*/
    React.createElement(InputContainer, null,
    /*#__PURE__*/
    React.createElement("label", {
      htmlFor: "password"
    }, copy.passwordInput[mode]),
    /*#__PURE__*/
    React.createElement("input", {
      id: "password",
      disabled: submitting,
      tabIndex: 2,
      value: password,
      onBlur: handleChange('password'),
      onChange: handleChange('password'),
      type: "password"
    })), renderConfirmPasswordInput &&
    /*#__PURE__*/
    React.createElement(InputContainer, null,
    /*#__PURE__*/
    React.createElement("label", {
      htmlFor: "confirmPassword"
    }, "Confirm password"),
    /*#__PURE__*/
    React.createElement("input", {
      id: "confirmPassword",
      disabled: submitting,
      tabIndex: 2,
      value: confirmPassword,
      onBlur: handleChange('confirmPassword'),
      onChange: handleChange('confirmPassword'),
      type: "password"
    })), renderReferalAndTC &&
    /*#__PURE__*/
    React.createElement(InputContainer, null,
    /*#__PURE__*/
    React.createElement("label", {
      htmlFor: "refferalPartner"
    }, partnerQuestion),
    /*#__PURE__*/
    React.createElement(SelectMenuItem, {
      type: "button",
      name: 'refferalPartner',
      id: 'refferalPartner',
      direction: "below",
      dispatch: function dispatch(_ref4) {
        var type = _ref4.type,
            payload = _ref4.payload;
        var selectedOptionValue = payload.option && payload.option.value;
        setRefferalPartner(selectedOptionValue);
      },
      disabled: submitting,
      options: partnerQuestionAnswers.map(function (_ref5) {
        var id = _ref5.id,
            answer = _ref5.answer;
        return {
          value: id,
          label: answer
        };
      }),
      value: refferalPartner,
      selected: refferalPartner && partnerQuestionAnswers.filter(function (_ref6) {
        var id = _ref6.id,
            answer = _ref6.answer;
        return id === refferalPartner;
      })[0].answer,
      mqSingleColumnBelow: MQ_FOR_TABLET_LANDSCAPE_BELOW
    })), error &&
    /*#__PURE__*/
    React.createElement(LoginError, null, "Error: ".concat(error, ".")),
    /*#__PURE__*/
    React.createElement(SubmitButton, {
      disabled: submitting,
      type: "submit",
      tabIndex: 2
    },
    /*#__PURE__*/
    React.createElement(SubmitText, null, submitting ? copy.ctaBusy[mode] : copy.cta[mode], submitting &&
    /*#__PURE__*/
    React.createElement(Spinner, null))), renderForgotPasswordLink &&
    /*#__PURE__*/
    React.createElement(ForgotContain, null,
    /*#__PURE__*/
    React.createElement(Link, {
      to: routeWithSearch('/reset-password')
    }, "Forgot password?")), renderReferalAndTC &&
    /*#__PURE__*/
    React.createElement(BottomLinksContainer, null, "By signing up, you agree to our ",
    /*#__PURE__*/
    React.createElement(Link, {
      to: routeWithSearch('/terms-of-service')
    }, "terms of service"), " and ",
    /*#__PURE__*/
    React.createElement("a", {
      href: "/privacy-policy/"
    }, "privacy policy"),
    /*#__PURE__*/
    React.createElement("br", null),
    /*#__PURE__*/
    React.createElement("br", null), "Already have an account? ",
    /*#__PURE__*/
    React.createElement(Link, {
      to: !redirectUrl ? routeWithSearch('/login') : routeWithRedirect('/login', redirectUrl)
    }, "Log in here"))), submitted && mode === MODES.SET_PW_SUBMIT &&
    /*#__PURE__*/
    React.createElement(SetPasswordContainer, null,
    /*#__PURE__*/
    React.createElement(LoginMessage, null,
    /*#__PURE__*/
    React.createElement("h1", null, "You're all set! We've successfully updated your password.")),
    /*#__PURE__*/
    React.createElement(SetPasswordLink, {
      href: routeWithSearch('/login')
    }, "Go To Login")), submitted && mode !== MODES.SET_PW_SUBMIT &&
    /*#__PURE__*/
    React.createElement(Success, {
      mode: mode
    },
    /*#__PURE__*/
    React.createElement("h1", null, "We\u2019re on it!"),
    /*#__PURE__*/
    React.createElement("h5", null, "We sent you an email with a reset link. Click the link inside to reset your password."),
    /*#__PURE__*/
    React.createElement(Link, {
      to: routeWithSearch('/login')
    },
    /*#__PURE__*/
    React.createElement(SuccessButton, null, copy.success[mode])))),
    /*#__PURE__*/
    React.createElement(BackgroundImageContainer, null,
    /*#__PURE__*/
    React.createElement(BackgroundImage, {
      src: buildCompressedUrl(bgImage),
      alt: "common room with fireplace"
    }))))
  );
}

function routeWithSearch(route) {
  var search = window.location.search;
  return "".concat(route).concat(search || '');
}

function routeWithRedirect(route, redirectUrl) {
  var search = window.location.search;
  return "".concat(route).concat(redirectUrl).concat(search || '');
}

var copy = {
  title: (_title = {}, _defineProperty(_title, MODES.LOGIN, 'Login'), _defineProperty(_title, MODES.SIGNUP_PACKAGE_SELECTION, 'Sign Up'), _defineProperty(_title, MODES.SET_PW_SUBMIT, 'Set Password'), _defineProperty(_title, MODES.RESET_PW_REQUEST, 'Reset your password'), _defineProperty(_title, MODES.RESET_PW_SUBMIT, 'Reset your password'), _title),
  description: (_description = {}, _defineProperty(_description, MODES.LOGIN, 'Log in to your account'), _defineProperty(_description, MODES.SIGNUP_PACKAGE_SELECTION, 'Create an account to continue'), _defineProperty(_description, MODES.SET_PW_SUBMIT, 'Set Password'), _defineProperty(_description, MODES.RESET_PW_REQUEST, 'Reset your password'), _defineProperty(_description, MODES.RESET_PW_SUBMIT, 'Reset your password'), _description),
  heading: (_heading = {}, _defineProperty(_heading, MODES.LOGIN, 'Welcome!'), _defineProperty(_heading, MODES.SIGNUP_PACKAGE_SELECTION, 'Create your Modsy account to get started'), _defineProperty(_heading, MODES.SET_PW_SUBMIT, 'Enter a new password for your account'), _defineProperty(_heading, MODES.RESET_PW_REQUEST, 'Forgot your password?'), _defineProperty(_heading, MODES.RESET_PW_SUBMIT, 'Reset your password'), _heading),
  subheading: (_subheading = {}, _defineProperty(_subheading, MODES.LOGIN, 'Login to your Modsy account'), _defineProperty(_subheading, MODES.SIGNUP_PACKAGE_SELECTION, ''), _defineProperty(_subheading, MODES.SET_PW_SUBMIT, ''), _defineProperty(_subheading, MODES.RESET_PW_REQUEST, 'It happens to the best of us! We’ll send you an email to reset your password.'), _defineProperty(_subheading, MODES.RESET_PW_SUBMIT, 'Please set your password below'), _subheading),
  passwordInput: (_passwordInput = {}, _defineProperty(_passwordInput, MODES.LOGIN, 'Password'), _defineProperty(_passwordInput, MODES.SIGNUP_PACKAGE_SELECTION, ''), _defineProperty(_passwordInput, MODES.SET_PW_SUBMIT, 'Enter password'), _defineProperty(_passwordInput, MODES.RESET_PW_REQUEST, ''), _defineProperty(_passwordInput, MODES.RESET_PW_SUBMIT, 'Enter password'), _passwordInput),
  cta: (_cta = {}, _defineProperty(_cta, MODES.LOGIN, 'Sign In'), _defineProperty(_cta, MODES.SIGNUP_PACKAGE_SELECTION, 'Sign Up'), _defineProperty(_cta, MODES.SET_PW_SUBMIT, 'Save Your Password'), _defineProperty(_cta, MODES.RESET_PW_REQUEST, 'Reset  Your Password'), _defineProperty(_cta, MODES.RESET_PW_SUBMIT, 'Sign In'), _cta),
  ctaBusy: (_ctaBusy = {}, _defineProperty(_ctaBusy, MODES.LOGIN, 'Logging In'), _defineProperty(_ctaBusy, MODES.SIGNUP_PACKAGE_SELECTION, 'Creating Account'), _defineProperty(_ctaBusy, MODES.SET_PW_SUBMIT, 'Save Password'), _defineProperty(_ctaBusy, MODES.RESET_PW_REQUEST, 'Reset Password'), _defineProperty(_ctaBusy, MODES.RESET_PW_SUBMIT, 'Set Password'), _ctaBusy),
  success: (_success = {}, _defineProperty(_success, MODES.LOGIN, ''), _defineProperty(_success, MODES.SIGNUP_PACKAGE_SELECTION, ''), _defineProperty(_success, MODES.SET_PW_SUBMIT, 'Success! Click here to return to login screen'), _defineProperty(_success, MODES.RESET_PW_REQUEST, 'Done'), _defineProperty(_success, MODES.RESET_PW_SUBMIT, 'Success! Click here to return to login screen'), _success)
};
var styles = {
  SetPasswordContainer: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    max-width: 368px;\n    align-self: center;\n    width: 100%;\n\n    ", " {\n      padding-bottom: 40px !important;\n      padding-left: 1.5rem !important;\n      padding-right: 1.5rem !important;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_BELOW),
  SetPasswordLink: styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 12px 16px;\n    height: 48px;\n    margin-top: 1.25rem;\n    width: 100%;\n    background-color: ", ";\n    border-radius: 4px;\n    border: 1px solid ", ";\n    color: white;\n    font-family: inherit;\n    letter-spacing: 0.54px;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 24px;\n    align-items: center;\n    text-align: center;\n    display: block;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: none;\n    }\n  "])), primaryM, primaryM),
  LoginPage: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n\n    width: 100%;\n    height: 100vh;\n    max-width: 100% !important;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n\n    padding: 0;\n    margin: 0 auto;\n  "]))),
  LogoContain: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n  "]))),
  LoginBody: styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    height: 100%;\n    flex-direction: row;\n  "]))),
  LoginMessage: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1rem;\n    text-align: center;\n    width: 100%;\n    align-self: center;\n\n    h1 {\n      color: #41434A;\n      font-size: 42px;\n      font-family: ", ";\n      font-weight: 600;\n      line-height: 49px;\n      margin: 0;\n      margin-bottom: 1rem;\n      font-style: normal;\n    }\n\n    h5 {\n      color: #41434A;\n      font-family: ", ";\n      font-size: 16px;\n      font-weight: normal;\n      line-height: 20px;\n      margin: 0;\n      font-style: normal;\n      margin: 0;\n    }\n  "])), fontFamilyHeadings, fontFamilyPrimary),
  LoginContainer: styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    background-color: #FAFAFA;\n    justify-content: center;\n    flex-grow: 0;\n    max-width: 41.666667%;\n    flex-basis: 41.666667%;\n    margin: 0 auto;\n    padding: 1.75rem 1rem 0 1rem;\n\n    ", " {\n      width: 100%;\n      min-width: 0 !important;\n      margin: 0;\n      padding: 1.75rem 0 40px 0;\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_BELOW),
  LoginForm: styled.form(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    max-width: 368px;\n    align-self: center;\n    width: 100%;\n\n    ", " {\n      padding-bottom: 40px !important;\n      padding-left: 1.5rem !important;\n      padding-right: 1.5rem !important;\n    }\n\n    ", ";\n  "])), MQ_FOR_TABLET_LANDSCAPE_BELOW, function (p) {
    return p.submitted && (p.mode !== MODES.SET_PW_SUBMIT ? "visibility: hidden; display: none;" : 'display: none;');
  }),
  InputContainer: styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    color: #5e5e5e;\n    font-size: 0.75rem;\n    font-weight: 700;\n    line-height: 1.125rem;\n    width: 100%;\n    margin-bottom: 0.625rem !important;\n    margin-top: 2rem !important;\n\n    label {\n      display: inline-block;\n      width: 100%;\n      margin-bottom: 0.25rem;\n      font-family: ", ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: 14px;\n      line-height: 18px;\n      color: #41434A;\n    }\n\n    input, select {\n      width: 100%;\n      height: 56px;\n      border-radius: 4px !important;\n      background-color: white;\n      border: 1px solid #8B8C90;\n      box-sizing: border-box;\n      font-size: 0.875rem;\n      padding-left: 0.5rem;\n    }\n  "])), fontFamilyPrimary),
  SelectMenuItem: styled(Dropdown)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 56px;\n    border-radius: 4px !important;\n    background-color: white;\n    border: 1px solid #8B8C90;\n    box-sizing: border-box;\n    font-size: 0.875rem;\n    padding-left: 0.5rem;\n    ", "\n\n    ", " {\n      max-height: 15.125rem;\n\n      ", " {\n        top: unset;\n        bottom: calc(100% + 1px);\n      }\n    }\n\n    ", " {\n      font-size: 0.875rem;\n\n      &:hover {\n        background-color: ", ";\n        font-weight: ", ";\n      }\n    }\n  "])), function (p) {
    return p.selected ? '' : 'justify-content: flex-end;';
  }, styles$1.Menu, function (p) {
    return p.mqSingleColumnBelow;
  }, styles$1.MenuItem, secondaryHighlightM, semiBold),
  BottomLinksContainer: styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-top: 2.5rem !important;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1rem;\n    text-align: center;\n    color: #41434A;\n    a {\n      color: ", ";\n      width: 100%;\n      text-decoration: none;\n      font-weight: 600;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n    span {\n      color: #41434A;\n    }\n  "])), primaryM),
  ForgotContain: styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-top: 24px;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    a {\n      color: ", ";\n      text-decoration: none;\n      font-weight: 600;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n    span {\n      color: #41434A;\n    }\n  "])), primaryM),
  SubmitButton: styled.button(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    padding: 12px 16px;\n    height: 48px;\n    margin-top: 2rem;\n    width: 100%;\n    background-color: ", ";\n    border-radius: 4px;\n    border: 1px solid ", ";\n    color: white;\n    font-family: inherit;\n    font-size: 1.125rem;\n    font-weight: 500;\n    line-height: 1.125rem;\n  "])), primaryM, primaryM),
  ButtonLink: styled.button(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    padding: 12px 16px;\n    height: 48px;\n    width: 100%;\n    background-color: white;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    color: ", ";\n    font-family: inherit;\n    font-size: 1.125rem;\n    font-weight: 500;\n    line-height: 1.125rem;\n  "])), primaryM, primaryM),
  SubmitText: styled.span(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 24px;\n    align-items: center;\n    text-align: center;\n    position: relative;\n  "])), fontFamilyPrimary),
  LoginError: styled.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: 1rem;\n  "])), redAlert),
  Spinner: styled(CtaSpinner)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: calc(50% - 0.4375rem);\n    left: calc(0% - 1.5rem);\n    z-index: 1;\n  "]))),
  Success: styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1rem;\n    text-align: left;\n    width: 100%;\n    align-self: center;\n    max-width: 368px;\n\n    h1 {\n      color: #41434A;\n      font-size: 42px;\n      font-family: ", ";\n      font-weight: 600;\n      line-height: 49px;\n      margin: 0;\n      margin-bottom: 1rem;\n      font-style: normal;\n    }\n\n    h5 {\n      color: #41434A;\n      font-family: ", ";\n      font-size: 16px;\n      font-weight: normal;\n      line-height: 20px;\n      margin: 0;\n      font-style: normal;\n      margin: 0;\n    }\n    ", " {\n      padding-bottom: 40px !important;\n      padding-left: 1.5rem !important;\n      padding-right: 1.5rem !important;\n    }\n  "])), fontFamilyHeadings, fontFamilyPrimary, MQ_FOR_TABLET_LANDSCAPE_BELOW),
  SuccessButton: styled.button(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    padding: 12px 16px;\n    height: 48px;\n    margin-top: 2rem;\n    width: 100%;\n    background-color: ", ";\n    border-radius: 4px;\n    border: 1px solid ", ";\n    color: white;\n    font-family: inherit;\n    font-size: 1.125rem;\n    font-weight: 500;\n    line-height: 1.125rem;\n"])), primaryM, primaryM),
  EmailSuggestionMessage: styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    font-size: 0.75rem;\n    margin-bottom: 0.625rem;\n\n    span {\n      cursor: pointer;\n      color: ", ";\n    }\n  "])), primaryM),
  BackgroundImageContainer: styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    display: grid;\n    height: 100vh;\n    width: 100%;\n    flex-grow: 0;\n    max-width: 58.333333%;\n    flex-basis: 58.333333%;\n\n    ", " {\n      display: none;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_BELOW),
  BackgroundImage: styled.img(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    min-height: 100%;\n    min-width: 1024px;\n    position: relative;\n    object-fit:cover\n  "])))
};
export default LoginResetPassword;
export { MODES };